module.exports = __webpack_public_path__ + "static/media/tyre-red-two3.9a04882d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-two3.png
// module id = 343
// module chunks = 0